import { useNavigate, useParams } from "react-router-dom"
import ProductImg from "../../assets/wristwatch.jpg"
import ProductImg2 from "../../assets/wristwatch2.webp"
import { useEffect, useState } from "react"
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import { IoChevronBack } from "react-icons/io5";
import Modal from "../../Modal";

const ProductDetail = () => {

    const { productId } = useParams()
    const Navigate = useNavigate()

    const [product, setProduct] = useState({})
    const [showModal, setShowModal] = useState(false)

    const deleteProduct = () => {
        // delete
        Navigate(-1)
    }

    useEffect(() => {
        setProduct(demoProduct)
    }, [])

    return (
        <>
            <div className=" p-4 sm:p-8">
                <div className=" flex items-center justify-between gap-2 flex-wrap">
                    <div onClick={() => Navigate(-1)} className=" flex items-center gap-2 flex-nowrap *:flex-none text-sm font-semibold text-gray-500 hover:text-tripstore-black cursor-pointer"><IoChevronBack /><span>Back</span></div>
                    <div className=" text-xl tracking-wide font-semibold uppercase">Product {productId}</div>
                </div>
                <div className=" mt-2 rounded-md bg-white p-4 sm:p-8 border-2 border-slate-300 shadow-lg">
                    <div className=" pb-2 w-full overflow-x-auto scrollbar small-scrollbar flex gap-2 *:flex-none flex-nowrap">
                        {
                            (product && product.img) &&
                            product.img.map((item, index) => (
                                <div key={index} className=" relative w-[200px] h-[200px] rounded overflow-hidden bg-black">
                                    <img src={item} className=" w-full h-full object-cover" alt="product img" />
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className=" mt-2 rounded-md bg-white p-4 sm:p-8 border-2 border-slate-300 shadow-lg">
                    <div className=" text-lg">Description</div>
                    <div className=" mt-2 text-sm">{(product && product.description) ?? ''}</div>
                    <div className=" mt-2 text-sm font-semibold flex items-center flex-wrap gap-2 *:text-nowrap">
                        <div className="">Category:</div>
                        <div className=" py-1 px-3 rounded-full bg-slate-300">{(product && product.category) ?? ''}</div>
                    </div>
                </div>
                <div className=" mt-2 rounded-md bg-white p-4 sm:p-8 border-2 border-slate-300 shadow-lg">
                    <div className=" w-full pb-2 overflow-x-auto scrollbar small-scrollbar">
                        <table className=" w-full border-2 border-slate-300 rounded">
                            <thead className=" bg-slate-300">
                                <tr className=" *:p-2 *:text-nowrap">
                                    <td>Size</td>
                                    <td>Price (&#8358;)</td>
                                    <td>Stock</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    (product && product.size) &&
                                    product.size.map((item, index) => (
                                        <tr key={index} className=" *:p-2 *:text-nowrap even:bg-slate-200">
                                            <td>{item.unit}</td>
                                            <td>{item.price.toLocaleString()}</td>
                                            <td>{item.stock}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className=" mt-2 font-semibold">Total Stock: {product.size ? product.size.reduce((total, item) => total + item.stock, 0) : 0}</div>
                </div>
                <div className=" mt-4 flex justify-between items-center gap-2 *:w-full sm:*:w-[200px] flex-wrap *:flex-none">
                    <button onClick={() => Navigate(`/admin/inventory/edit/${productId}`)} className=" flex items-center justify-center gap-2 flex-nowrap *:flex-none border-2 border-tripstore-black hover:bg-tripstore-black hover:text-white"><FaEdit /><span className=" text-nowrap">Edit Product</span></button>
                    <button onClick={() => setShowModal(true)} className=" flex items-center justify-center gap-2 flex-nowrap *:flex-none border-2 border-red-500 text-red-500 hover:bg-red-500 hover:text-white"><FaRegTrashAlt /><span className=" text-nowrap">Remove Product</span></button>
                </div>
            </div>
            {showModal && <Modal setShowModal={setShowModal} title={'DELETE PRODUCT'} info={'Proceed to remove this product from record'} onProceed={deleteProduct} isProceedModal={true} />}
        </>
    )
}

export default ProductDetail

const demoProduct = {
    img: [ProductImg, ProductImg2],
    description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Et, molestias. Rem amet, incidunt nesciunt eos obcaecati repellendus autem error deleniti in aut quae quod laboriosam optio vel ea. Qui, ratione?",
    category: "Fashion",
    size: [
        { unit: 'S', price: 12000, stock: 20 },
        { unit: 'M', price: 16000, stock: 36 },
        { unit: 'L', price: 16500, stock: 24 },
        { unit: 'XL', price: 18000, stock: 20 }
    ]
}